import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import putEquivalentSecurityList from "../requests/putEquivalentSecurityList";
import { equivalentSecurityListKeyMaker } from "./useEquivalentSecurityList";
import { equivalentSecurityListsKeyMaker } from "./useEquivalentSecurityLists";
export default function usePutEquivalentSecurityList(listId, config) {
    const queryClient = useQueryClient();
    const idemDescriptor = `put-equivalent-security-list-${listId}`;
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(idemDescriptor));
    const mutation = useMutation({
        mutationFn: async (body) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return putEquivalentSecurityList(listId, body, idempotencyKey, config);
        },
        onSuccess: () => {
            setIdempotencyKey(genIdempotencyKey(idemDescriptor));
            queryClient.invalidateQueries({
                queryKey: equivalentSecurityListKeyMaker(listId),
            });
            queryClient.invalidateQueries({
                queryKey: equivalentSecurityListsKeyMaker(),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePutEquivalentSecurityList.js.map